import { useMemo } from "react";
import { Permissions_new } from "~/constants";
import { useOdPermissions } from "./useOdPermissions";


/**
 * Checks if a user has any of specified permissions.
 *
 * @param {Array<string>} requiredPermits - An array of permission names.
 * @returns {boolean} Whether the user has any of specified permissions or not.
 */
export const useHasPermit = (requiredPermits: Permissions_new[]) => {
  const permissions = useOdPermissions()
  return useMemo(() => {
    return requiredPermits.some(p => permissions.has(p))
  }, [permissions, JSON.stringify(requiredPermits)])
}
